exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titulo[data-v-1116117c]{padding-top:30px}.imagen[data-v-1116117c]{border-radius:6px;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);margin-top:30px}.box[data-v-1116117c],.time[data-v-1116117c]{margin-top:30px}.icon-lista[data-v-1116117c]{vertical-align:bottom}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1116117c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/informes/Subitem.vue
// module id = 558
// module chunks = 0